/**
 * Utility functions for SEO-friendly URLs and slugs.
 */

/**
 * Generates a URL-friendly slug from product details similar to the competitor.
 * @param {Object} product The product object from Firestore.
 * @returns {string} A URL-friendly slug.
 */
export const generateProductSlug = (product) => {
  if (!product) return '';

  // Collect relevant parts for the slug
  const parts = [
    product.brand,
    product.name,
    product.model,
    product.processor,
    product.generation,
    product.ramSize,
    product.storageSize,
    product.storageType,
    product.screenSize,
    product.graphicsCard,
    product.operatingSystem,
    product.condition || 'refurbished'
  ].filter(Boolean);

  // Split into words, remove duplicates (case-insensitive), and join
  const seenWords = new Set();
  const uniqueWords = [];

  parts.join(' ').toLowerCase().split(/\s+/).forEach(word => {
    const cleaned = word.replace(/[^\w-]/g, '').trim();
    if (cleaned && !seenWords.has(cleaned)) {
      seenWords.add(cleaned);
      uniqueWords.push(cleaned);
    }
  });

  return uniqueWords
    .join('-')
    .replace(/-+/g, '-')
    .trim();
};

/**
 * Gets the base path for a product type.
 * @param {string} productType The type of product (laptop, monitor, etc.)
 * @returns {string} The URL prefix.
 */
export const getProductPathPrefix = (productType) => {
  switch (productType?.toLowerCase()) {
    case 'laptop': return 'products';
    case 'monitor': return 'monitor';
    case 'desktop': return 'desktop';
    case 'minipc': return 'mini-pc';
    case 'allinone': return 'all-in-one-pc';
    case 'accessory': return 'accessory';
    default: return 'products';
  }
};
